export const styleWrapper = `
`;

export const styleOffer = `
  border: 1px solid #dcdfe6;
  margin-bottom: 8px;
  border-radius: 5px;
`;

export const styleStretch = `
  padding: 16px 8px;
  &+hr {
    margin: 0 8px;
    border-bottom: 0px;
    border-top: 1px solid #dcdfe6;
  }
  &+button {
    display: block;
    max-width: 229px;
    margin: 16px auto;
  }
  .header-stretch {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    div:first-of-type {
      i, strong {
        color: #2f3e5e;
      }
      i {
        margin-right: 16px;
      }
    }
  }
  .header-periods {
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }
  .bounds+button {
    margin-top: 16px;
  }
  .bounds>div {
    display: grid;
    grid-template-columns: 20px auto;
    grid-template-areas:
      "radio airline"
      "info info"
      "details details";
    background-color: #fff;
    grid-gap: 8px 16px;
    padding: 8px 16px;
    border-radius: 5px;
    transition: all .1s ease-in;
    @media screen and (min-width: 768px) {
      grid-template-columns: 20px 130px auto minmax(100px, 15%);
      grid-template-areas: "radio airline info details";
    }
    &.selected {
      background-color: #f4f5f7;
    }
    .radio {
      grid-area: radio;
      margin: auto 0;
      display: flex;
      align-items: center;
      label, label:before {
        width: 20px;
      }
      label {
        margin-bottom: 0px;
      }
    }
    .airline {
      grid-area: airline;
      display: flex;
      align-items: center;
      font-weight: 600;
      color: #223254;
      .flag {
        min-width: 24px;
        width: 24px;
        height: 24px;
        border-radius: 2px;
        overflow: hidden;
        margin-right: 16px;
        background: #bddbeb;
        img {
          opacity: 0;
          transition: opacity .15s ease-in-out;
        }
      }
    }
    .info {
      grid-area: info;
      display: flex;
      line-height: 20px;
      align-items: center;
      justify-content: space-between;
      .departure, .duration, .arrival {
        font-size: 12px;
      }
      .departure, .arrival {
        strong {
          position: relative;
          display: block;
          font-weight: 700;
          font-size: 16px;
          color: #223254;
          span {
            font-size: 12px;
            color: #e40e31;
            position: absolute;
            right: -16px;
          }
        }
      }
      .duration {
        min-width: 60px;
        text-align: center;
        color: #9098a9;
        font-weight: 500;
        margin: 0 8px;
        .time, .stops {
          display: block;
        }
      }
    }
    .details {
      grid-area: details;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (min-width: 768px) {
        justify-content: flex-end;
      }
      a {
        font-size: 12px;
        padding: 8px 0px;
        text-decoration: none;
        font-weight: 600;
        &:active, &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  &:last-of-type {
    border-bottom: 1px solid #dcdfe6;
  }
`;

export const styleDetails = `
  .header {
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 8px;
    i, strong {
      color: #2f3e5e;
    }
    i {
      margin-right: 16px;
    }
  }
  .boundInfo {
    background: #f4f5f7;
    margin-top: 8px;
    padding: 8px 16px;
    border-radius: 5px;
    line-height: 1.3em;
    .stretch {
      border-bottom: 1px solid #dcdfe6;
      padding-bottom: 8px;
      margin: 0 0 8px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      strong, .departure, .arrival, .stops {
        flex: 1;
        font-weight: 600;
      }
      .departure, .arrival, .stops {
        font-size: 12px;
      }
      strong {
        color: #223254;
        font-size: 14px;
      }
      .stops {
        line-height: 1;
        white-space: nowrap;
        padding: 0px 8px;
      }
      .departure {
        text-align: right;
      }
      .arrival {
        text-align: left;
        i {
          font-style: normal;
          color: #e40e31;
          margin-left: 4px;
        }
      }
      strong, .stops {
        text-align: center;
      }
    }
    .info {
      list-style: none;
      padding: 0;
      margin: 0;
      font-weight: 600;
      li {
        font-size: 12px;
        margin: 0 0 4px;
        text-align: center;
        &.arrive {
          font-weight: 700;
          color: #223254;
          font-size: 14px;
        }
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
  .luggage {
    border-radius: 5px;
    padding: 16px;
    background-color: #f4f5f7;
    margin-top: 16px;
    .heading {
      font-weight: 700;
      font-size: 14px;
      color: #223254;
      border-bottom: 1px solid #dcdfe6;
      padding-bottom: 8px;
      margin: 0 0 8px 0;
    }
    .info {
      text-align: left;
      font-size: 12px;
      color: #223254;
      div {
        margin-top: 8px;
        &:first-of-type {
          margin-top: 0;
        }
      }
      p {
        margin: 0;
        &.stretch {
          margin-bottom: 8px;
          font-weight: 700;
        }
      }
      .icon-message {
        display: flex;
        justify-content: left;
        line-height: 1.7em;
        &.green i {
          color: #1abc9c;
        }
        &.red i {
          color: #e40e31;
        }
        p {
          color: #223254;
          padding-top: 4px;
          font-family: 'Montserrat', sans-serif;
          padding-left: 8px;
          margin-bottom: 0;
        }
      }
      &.expanded .icon-message {
        margin-top: 8px;
      }
    }
  }
  &+button {
    margin-top: 24px;
  }
`;

export const segmentBounds = `
  margin-top: 24px;
  line-height: 1.3em;
`;

export const items = `
	font-size: 12px;
	display: flex;
	margin-bottom: 0;
	margin-left: 0;
	align-items: center;

  li {
    display: flex;
		align-items: center;
		font-weight: 600;
		padding: 0 8px 0 0;

    &.cabin-type {
			color: #9098a9;
			font-weight: 400;
			padding-right: 0;
    }

    &:before {
      vertical-align: middle;
      display: inline-block;
      content: '';
      border-radius: 100%;
      height: 4px;
      width: 4px;
      margin-right: 8px;
      background-color: #dcdfe6;
    }

    &:first-of-type {
      padding-left: 0;
      &:before {
        display: none;
      }
    }
  }

  @media screen and (min-width: 768px) {
		margin-bottom: 24px;

		li {
			padding-left: 16px;
			padding-right: 0;

			&:before {
				margin-right: 16px;
			}
		}
  }
`;

export const timeline = `
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  position: relative;

  &:last-of-type {
    padding-bottom: 0;
    margin-bottom: 0;

    ul li:before {
			display: none;
    }
  }

  i {
		margin-right: 24px;
		color: #223254;
  }
`;

export const time = `
  color: #223254;
  flex-basis: 4rem;
  text-align: center;

  strong {
    font-weight: 600;
  }
`;

export const listUnstyled = `
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-size: 12px;
    margin: 0 0 4px;

    &.arrive {
      font-weight: 700;
      color: #223254;
      font-size: 14px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const segmentList = `
  ${listUnstyled};
  flex: 1;
  margin-left: 24px;

  li {
    margin: 0;
    strong {
      color: #223254;
      font-size: 14px;
      font-weight: 600;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      height: calc(100% - 24px);
      left: calc(10px);
      border: 1px solid #dcdfe6;
      background: #fff;
      top: 36px;
    }
  }
`;

export const classType = `
  color: #1abc9c;
`;

export const change = `
  text-indent: -70px;
	font-weight: 600;
	padding: 16px 0 0 0;
	color: #1abc9c;

  &:before {
    border: 1px dashed #dcdfe6 !important;
  }
`;

export const daysAfterDeparture = `
	color: #e40e31;
	font-weight: 600;
`;
